import React from "react";
import { useTranslation } from "react-i18next";
import { BuyXPayYPromotion } from "../../../../types/productApiTypes";
import Icon from "../../../../../../../common/components/Icon/Icon";

interface PromoDisclaimerProps {
  promotion?: BuyXPayYPromotion;
  className?: string;
}

/**
 * Renders a marketing information block about active "Buy X Pay Y" promotions.
 */
const PromoDisclaimer: React.FC<PromoDisclaimerProps> = ({
  promotion,
  className = "",
}) => {
  const { t } = useTranslation();

  // If there is no promotion or the product isn't eligible, render nothing.
  if (!promotion?.isEligible) {
    return null;
  }

  return (
    <div className={`promo-disclaimer ${className}`}>
      <div className="promo-disclaimer__icon-box">
        <Icon iconName="ticket-outlined" className="icon--stroke-thick" />
      </div>
      <div className="promo-disclaimer__content">
        <p
          dangerouslySetInnerHTML={{
            __html: t("productInfoDetails.promoDisclaimer", {
              buy: promotion.buyQty,
              pay: promotion.payQty,
              defaultValue: `This product is part of the Buy ${promotion.buyQty} Pay ${promotion.payQty} campaign.`,
            }),
          }}
        />
      </div>
    </div>
  );
};

export default PromoDisclaimer;
